import * as React from 'react';
import NewRegeneratePasswordForm from '@App/components/forms/NewRegeneratePasswordForm';

const RegeneratePasswordPage: any = () => {
  return (
    <React.Fragment>
      <section className="section">
        <h1 className="section-title">Modifier mon mot de passe</h1>
        <NewRegeneratePasswordForm />
      </section>
    </React.Fragment>
  );
};

export default RegeneratePasswordPage;
